module.exports = __webpack_public_path__ + "img/watch-wind.6b71285c.svg";